/* eslint-disable ember/no-classic-components */
import Component, { setComponentTemplate } from "@ember/component";
import { service } from "@ember/service";
import { tagName } from "@ember-decorators/component";
import { modifier } from "ember-modifier";
import componentForRow from "discourse/helpers/component-for-row";
import { disableBodyScroll, enableBodyScroll, locks } from "discourse/lib/body-scroll-lock";
import { resolveComponent } from "select-kit/components/select-kit";
import { precompileTemplate } from "@ember/template-compilation";
const SelectKitCollection = dt7948.c(class SelectKitCollection extends Component {
  static {
    dt7948.g(this.prototype, "site", [service]);
  }
  #site = (dt7948.i(this, "site"), void 0);
  bodyScrollLock = modifier(element => {
    if (this.site.desktopView) {
      return;
    }
    const isChildOfLock = locks.some(lock => lock.targetElement.contains(element));
    if (isChildOfLock) {
      disableBodyScroll(element);
    }
    return () => {
      if (isChildOfLock) {
        enableBodyScroll(element);
      }
    };
  });
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.collection.content.length}}\n      <ul class=\"select-kit-collection\" aria-live=\"polite\" role=\"menu\" {{this.bodyScrollLock}}>\n        {{#each this.collection.content as |item index|}}\n          {{#let (resolveComponent this (componentForRow this.collection.identifier item this.selectKit)) as |RowComponent|}}\n            <RowComponent @item={{item}} @index={{index}} @value={{this.value}} @selectKit={{this.selectKit}} />\n          {{/let}}\n        {{/each}}\n      </ul>\n    {{/if}}\n  ", {
      strictMode: true,
      scope: () => ({
        resolveComponent,
        componentForRow
      })
    }), this);
  }
}, [tagName("")]);
export default SelectKitCollection;